import styles from './style.css'
import {Field, reduxForm} from 'redux-form'
import {Link} from 'react-router'
import ResetPasswordField from 'components/Fields/ResetPasswordField/ResetPasswordField'

const validate = values => {
  const errors = {}
  if (!values.email) {
    errors.email = 'The email address is required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'The value is not a valid email address'
  }
  return errors
}

let ResetPasswordFormInvalid = class ResetPasswordFormInvalid extends React.Component {
  render () {
    return (
      <div className='col-md-12 no-padding'>
        <form onSubmit={this.props.handleSubmit}>
          <p className={'text-center ' + styles['description-reset-password']}>
            The link provided is already expired or no longer match, please resubmit your email and try again.
          </p>
          <Field
            component={ResetPasswordField}
            name='email'
            maxLength='40'
            autoCorrect='off'
            autoCapitalize='off'
            placeholder='Registered email address'
            spellCheck='false'
          />
          <div className={styles['submit-btn-container']}>
            <button type='submit' className={'btn btn-primary ' + styles['submit-btn']}>
              {this.props.btnText}
            </button>
          </div>
        </form>
        <div className={'col-md-12 col-xs-12 text-center ' + styles['back-to-login']}>
          <Link to='/login' className='text-center'>Back to login</Link>
        </div>
      </div>
    )
  }
}

ResetPasswordFormInvalid.propTypes = {
  dispatch: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  btnText: React.PropTypes.string
}

const mapFormValidation = {
  form: 'ResetPasswordFormInvalid',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

export default reduxForm(mapFormValidation)(ResetPasswordFormInvalid)



// WEBPACK FOOTER //
// ./app/pages/ResetPassword/ResetPasswordFormInvalid.js